import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getGroups, updateGroup, deleteGroup } from '../services/api';
import '../styles/Dashboard.css';

function Dashboard({ user }) {
  const [groups, setGroups] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [newGroupName, setNewGroupName] = useState('');
  const [newGroupColor, setNewGroupColor] = useState('#667eea');
  const [loading, setLoading] = useState(true);

  const colors = [
    '#667eea', '#764ba2', '#f093fb', '#4facfe',
    '#43e97b', '#fa709a', '#fee140', '#30cfd0',
    '#a8edea', '#ff6b6b', '#4ecdc4', '#45b7d1'
  ];

  const navigate = useNavigate();

  useEffect(() => {
    loadGroups();
  }, []);

  const loadGroups = async () => {
    try {
      const response = await getGroups();
      setGroups(response.data.groups);
      setLoading(false);
    } catch (error) {
      console.error('שגיאה בטעינת קבוצות:', error);
      setLoading(false);
    }
  };

  const handleEditGroup = async () => {
    if (!newGroupName.trim()) return;
    try {
      await updateGroup(selectedGroup._id, { 
        name: newGroupName,
        color: newGroupColor 
      });
      setNewGroupName('');
      setNewGroupColor('#667eea');
      setSelectedGroup(null);
      setShowEditModal(false);
      loadGroups();
    } catch (error) {
      console.error('שגיאה בעדכון קבוצה:', error);
      alert('שגיאה בעדכון קבוצה');
    }
  };

  const handleDeleteGroup = async (e, groupId) => {
    e.stopPropagation();
    if (!window.confirm('האם אתה בטוח שברצונך למחוק את הקבוצה?')) return;
    try {
      await deleteGroup(groupId);
      loadGroups();
    } catch (error) {
      console.error('שגיאה במחיקת קבוצה:', error);
      alert('שגיאה במחיקת קבוצה');
    }
  };

  const openEditModal = (e, group) => {
    e.stopPropagation();
    setSelectedGroup(group);
    setNewGroupName(group.name);
    setNewGroupColor(group.color || '#667eea');
    setShowEditModal(true);
  };

  if (loading) {
    return <div className="page-loading">טוען...</div>;
  }

  return (
    <div className="dashboard-page">
      {/* Header */}
      <div className="page-header">
        <h2>🏠 דף הבית</h2>
        <p>{groups.length} קבוצות</p>
      </div>

      {/* Groups Grid */}
      <div className="page-content">
        {groups.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📭</div>
            <h3>אין לך קבוצות עדיין</h3>
            <p>לחץ על "קבוצה חדשה" בתפריט כדי להתחיל</p>
          </div>
        ) : (
          <div className="groups-grid">
            {groups.map(group => (
              <div 
                key={group._id} 
                className="group-card"
                onClick={() => navigate(`/group/${group._id}`)}
              >
                <div className="group-card-color" style={{ background: group.color || '#667eea' }}></div>
                <div className="group-card-content">
                  <div className="group-card-header">
                    <h3>{group.name}</h3>
                    {group.adminId._id === user.id && (
                      <div className="group-card-actions">
                        <button 
                          className="group-action-btn"
                          onClick={(e) => openEditModal(e, group)}
                          title="ערוך"
                        >
                          ✏️
                        </button>
                        <button 
                          className="group-action-btn danger"
                          onClick={(e) => handleDeleteGroup(e, group._id)}
                          title="מחק"
                        >
                          🗑️
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="group-card-info">
                    <span className="info-item">👥 {group.members.length} חברים</span>
                    {group.adminId._id === user.id && (
                      <span className="admin-badge">מנהל</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Edit Group Modal */}
      {showEditModal && (
        <div className="modal-overlay" onClick={() => { setShowEditModal(false); setSelectedGroup(null); }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>עריכת קבוצה</h3>
            
            <div className="form-group">
              <label>שם הקבוצה</label>
              <input
                type="text"
                value={newGroupName}
                onChange={(e) => setNewGroupName(e.target.value)}
                className="input-field"
                autoFocus
              />
            </div>
            
            <div className="color-picker-section">
              <label>בחר צבע</label>
              <div className="color-picker">
                {colors.map(color => (
                  <div
                    key={color}
                    className={`color-option ${newGroupColor === color ? 'selected' : ''}`}
                    style={{ backgroundColor: color }}
                    onClick={() => setNewGroupColor(color)}
                  />
                ))}
              </div>
            </div>
            
            <div className="modal-actions">
              <button className="btn-primary" onClick={handleEditGroup}>שמור</button>
              <button className="btn-secondary" onClick={() => { setShowEditModal(false); setSelectedGroup(null); }}>ביטול</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;